module.exports = __webpack_public_path__ + "media/images/partner/media/radio_koeln-5cf349f00caac3be6375b1bb2fc52a68.png";